// extracted by mini-css-extract-plugin
export var clauseRow = "_g4-6";
export var emptyState = "_g4-d";
export var filterContent = "_g4-a";
export var filterGroup = "_g4-1";
export var filterGroupContainer = "_g4-0";
export var nestedGroup = "_g4-2";
export var nestedGroupContent = "_g4-b";
export var nestedGroupDepth1 = "_g4-3";
export var nestedGroupDepth2 = "_g4-4";
export var nestedGroupDepth3 = "_g4-5";
export var nestedGroupEmpty = "_g4-c";
export var operatorAnd = "_g4-8";
export var operatorOr = "_g4-9";
export var operatorToggle = "_g4-7";
export var removeGroupButton = "_g4-e";